__turbopack_context__.v({
  "active": "slider-section-module-scss-module__5WGEYq__active",
  "arrow": "slider-section-module-scss-module__5WGEYq__arrow",
  "bg-standard": "slider-section-module-scss-module__5WGEYq__bg-standard",
  "bg-subtle": "slider-section-module-scss-module__5WGEYq__bg-subtle",
  "bullet": "slider-section-module-scss-module__5WGEYq__bullet",
  "disabled": "slider-section-module-scss-module__5WGEYq__disabled",
  "nav": "slider-section-module-scss-module__5WGEYq__nav",
  "placeholder": "slider-section-module-scss-module__5WGEYq__placeholder",
  "section": "slider-section-module-scss-module__5WGEYq__section",
  "slides": "slider-section-module-scss-module__5WGEYq__slides",
  "text": "slider-section-module-scss-module__5WGEYq__text",
});
